import axios from "axios";
import { treinamentoUsuariosService } from "./treinamentoUsuariosService";

const N8N_WEBHOOK_URL =
  "https://n8n.devops.multpex.com.br/webhook/dd715c44-d672-4c84-9711-b33164324d6d";

const LOCAL_STORAGE_KEY = "aviso_treinamento_ultima_exibicao";

const getTenantFromHost = () => {
  const hostParts = window.location.host.split(".");
  return hostParts[1] ? hostParts[0] : null;
};

const notificarWebhook = (
  motivo,
  userEmail,
  dataVencimento = null,
  docId = null,
  userSap = null,
  userName = null,
  tipoTreinamentoWeb = null
) => {
  const tenant = getTenantFromHost();
  const body = { motivo, tenant, user_email: userEmail };
  if (dataVencimento) body.data_vencimento = dataVencimento;
  if (docId) body.docId = docId;
  if (userSap) body.userSap = userSap;
  if (userName) body.userName = userName;
  if (tipoTreinamentoWeb) body.tipoTreinamentoWeb = tipoTreinamentoWeb;
  return axios.post(N8N_WEBHOOK_URL, body).catch(() => {});
};

const deveExibirModal = () => {
  const ultimaExibicao = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!ultimaExibicao) return true;
  const diasDesdeUltimaExibicao =
    (Date.now() - Number(ultimaExibicao)) / (1000 * 60 * 60 * 24);
  return diasDesdeUltimaExibicao >= 7;
};

const registrarExibicaoModal = () => {
  localStorage.setItem(LOCAL_STORAGE_KEY, String(Date.now()));
};

const verificarTreinamento = async (userEmail) => {
  const tenant = getTenantFromHost();
  if (!tenant || !userEmail) return { acao: "nenhuma" };

  try {
    const resposta = await treinamentoUsuariosService.listar({
      tenant,
      userEmail,
    });

    const resultados = resposta.data?.results ?? [];
    const registro = resultados.find((r) => r.userEmail === userEmail);

    if (!registro || !registro.dataVencimentoTreinamentoWeb) {
      if (deveExibirModal()) {
        registrarExibicaoModal();
        return {
          acao: "exibirModal",
          tenant,
          userEmail,
          docId: registro?.id || null,
          userSap: registro?.userSap || null,
          userName: registro?.userName || null,
          tipoTreinamentoWeb: registro?.tipoTreinamentoWeb || null,
        };
      }
      return { acao: "nenhuma" };
    }

    const dataVencimento = new Date(registro.dataVencimentoTreinamentoWeb);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    if (dataVencimento < hoje) {
      if (registro.tipoTreinamentoWeb === "calendario" && deveExibirModal()) {
        registrarExibicaoModal();
        return {
          acao: "exibirModalCalendarioVencido",
          tenant,
          userEmail,
          docId: registro.id || null,
          userSap: registro.userSap || null,
          userName: registro.userName || null,
          tipoTreinamentoWeb: registro.tipoTreinamentoWeb,
          dataVencimento: registro.dataVencimentoTreinamentoWeb,
        };
      }

      if (deveExibirModal()) {
        registrarExibicaoModal();
        return {
          acao: "exibirModalVencido",
          tenant,
          userEmail,
          docId: registro.id || null,
          userSap: registro.userSap || null,
          userName: registro.userName || null,
          tipoTreinamentoWeb: registro.tipoTreinamentoWeb,
          dataVencimento: registro.dataVencimentoTreinamentoWeb,
        };
      }
      await notificarWebhook(
        "vencido",
        userEmail,
        registro.dataVencimentoTreinamentoWeb,
        registro.id,
        registro.userSap,
        registro.userName,
        registro.tipoTreinamentoWeb
      );
      return { acao: "nenhuma" };
    }

    return { acao: "nenhuma" };
  } catch {
    return { acao: "nenhuma" };
  }
};

export const avisoTreinamentoService = {
  verificarTreinamento,
  notificarWebhook,
};
